import { Directive, ElementRef, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { AppData } from './appdata';
const isNullOrUndefined = (val: any) => val === null || val === undefined;

@Directive({
  selector: '[canUserAccess]'
})
export class CanUserAccess {

  private FeatureName = [];
  bInit: boolean = false;
  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
  }

  ngOnInit() {
    if (!this.bInit)
      this.updateView();
    this.bInit = true;
  }

  @Input()
  set canUserAccess(val) {
    this.FeatureName = val;
    this.updateView();
  }

  private updateView() {
    if (this.hasAccess(this.FeatureName)) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  private hasAccess(FeatureName: any) {
    // Super Admin or default role bypasses restrictive checks
    if (!AppData.Instance() || AppData.Instance().SelectedRoleName === 'Super Admin' || !AppData.Instance().SelectedRoleName) {
      return true;
    }

    let access = false;
    const appInfo = AppData.Instance().AppUserSettingInfo;
    if (appInfo && appInfo.RoleFeatureLinkInfoController && appInfo.RoleFeatureLinkInfoController.length > 0) {
      for (let f in FeatureName) {
        var ff = appInfo.RoleFeatureLinkInfoController.filter(function (v) {
          return (
            v && v.FeatureName == FeatureName[f]
            && AppData.Instance().SelectedRoleName == v.RoleName
          );
        });
        if (ff && ff.length > 0) {
          access = true;
          break;
        }
      }
    } else {
      // Fallback: allow access if role feature link data is empty
      access = true;
    }
    return access;
  }
}
